import { autoUpdate, computePosition, offset, shift, size } from '@floating-ui/dom';
import { cn } from '@helpers/cn';
import { useLayoutEffect, useRef } from 'react';

import { overlapTriggerOffset } from './helpers/overlapTriggerOffset';
import { TProps } from './types/TProps';

const matchTriggerWidth = size({
  apply: ({ rects, elements }) => {
    elements.floating.style.width = `${rects.reference.width}px`;
  },
});

export const FormFieldSelectOptionsPanel = ({
  className,
  children,
  placement = 'bottom-start',
  triggerRef,
  ...rest
}: TProps) => {
  const panelRef = useRef<HTMLSpanElement>(null);

  useLayoutEffect(() => {
    const trigger = triggerRef.current;
    const panel = panelRef.current;

    if (!trigger || !panel) {
      return;
    }

    panel.style.width = `${trigger.getBoundingClientRect().width}px`;

    return autoUpdate(trigger, panel, () => {
      computePosition(trigger, panel, {
        placement,
        strategy: 'fixed',
        middleware: [offset(overlapTriggerOffset), matchTriggerWidth, shift()],
      }).then(({ x, y }) => {
        panel.style.left = `${x}px`;
        panel.style.top = `${y}px`;
      });
    });
  }, [placement, triggerRef]);

  return (
    <span
      ref={panelRef}
      className={cn(
        'optionsWrapper fixed left-0 top-0 z-1000 block overflow-hidden rounded-md',
        '!text-field-foreground',
        'border border-border shadow-popover',
        'bg-field-surface',
        className,
      )}
      {...rest}
    >
      {children}
    </span>
  );
};
